export const getStyleOfSize =(size,flag)=>{
  if(flag ==="wrap" && size && size < 100 )
  return 'd-flex align-items-center flex-column'
  if(!flag && size && size < 100 )
  return 'd-table mt-auto mb-auto '

}
